import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AlertService {
  alertsList: any[] = [];

  constructor(router: Router) {
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.removeAll();
        }
    });
  }

  getAlerts(): any[]  {
    return this.alertsList;
  }

  add(type, message) {
    this.alertsList.push({
      type: type,
      message: message
    });
    
  }

  remove(index) {
    this.alertsList.splice(index, 1);
  }

  removeAll() {
    this.alertsList = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/alert/services/alert.service.ts